"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSetting = exports.listSettings = void 0;
const ApiClient_1 = require("../ApiClient");
const listSettings = () => ApiClient_1.apiClient.get('/api/settings');
exports.listSettings = listSettings;
const updateSetting = (key, value) => ApiClient_1.apiClient.put(`/api/settings/${encodeURIComponent(key)}`, { value });
exports.updateSetting = updateSetting;
